import { Controller, useFormContext } from 'react-hook-form';
import { PageLayout, Button, SettingItem } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { DefinitionsBar } from '../definitionsBar/DefinitionsBar';
import { Input } from 'ui/input/Input';

import * as Styled from './PasswordPolicy.styles';
import { UpdatePasswordsPolicyFormBody, PasswordsPolicyProps } from './PasswordPolicy.types';

export const PasswordPolicy = ({ onSubmit, isLoading }: PasswordsPolicyProps) => {
  const { formatMessage } = useLocale();

  const {
    handleSubmit,
    formState: { errors, isValid },
  } = useFormContext<UpdatePasswordsPolicyFormBody>();

  return (
    <PageLayout
      header={formatMessage({ id: AppMessages['definitions.passwordPolicy.title'] })}
      renderContent={() => (
        <>
          <DefinitionsBar />

          <SettingItem>
            <Styled.Form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="minimumPasswordLength"
                render={({ field }) => (
                  <Input
                    {...field}
                    value={field.value || ''}
                    label={formatMessage({ id: AppMessages['definitions.passwordPolicy.minLength.label'] })}
                    placeholder={formatMessage({
                      id: AppMessages['definitions.passwordPolicy.minLength.placeholder'],
                    })}
                    type="number"
                    errorMessage={errors?.minimumPasswordLength?.message}
                  />
                )}
              />
              <Controller
                name="passwordRenewalDays"
                render={({ field }) => (
                  <Input
                    {...field}
                    value={field.value || ''}
                    label={formatMessage({ id: AppMessages['definitions.passwordPolicy.numberOfDays.label'] })}
                    placeholder={formatMessage({
                      id: AppMessages['definitions.passwordPolicy.numberOfDays.placeholder'],
                    })}
                    type="number"
                    errorMessage={errors?.passwordRenewalDays?.message}
                  />
                )}
              />
              <Styled.SubmitWrapper>
                <Button
                  isLoading={isLoading}
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="small"
                  disabled={!isValid}
                >
                  {formatMessage({ id: AppMessages['common.save'] })}
                </Button>
              </Styled.SubmitWrapper>
            </Styled.Form>
          </SettingItem>
        </>
      )}
    />
  );
};
